const riot = require('riot');

riot.tag2('module-emoji-picker', '<div ref="emoji_container"></div>', '', '', function(opts) {
    this.on('mount', () => {
      if (spat.isBrowser) {
        app.emoji.load(this.refs.emoji_container, this.opts.options || {});
      }
    });
});